import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';

import Page from 'layout/Page';
import { Message } from 'components/shared';

const EmptyCannedDashboard = ({ masterObjectName }) => {
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  return (
    <Page title="404">
      <Box marginLeft="20px" marginRight="20px">
        <Message
          type="info"
          text={`No dashboards related to ${masterObjectName} were found.`}
          onClose={goBack}
        />
      </Box>
    </Page>
  );
};

EmptyCannedDashboard.propTypes = {
  masterObjectName: PropTypes.string.isRequired
};

export default EmptyCannedDashboard;
